import React from 'react';

import { images } from '../../constants';

const SubHeading = ({ title }) => (
  <div>
    <p className='p__italiana'>{title}</p>
    <img src={images.leaf} alt='leaf' className='leaf__img' />
  </div>
);

export default SubHeading;
